import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Variant = makeShortcode("Variant");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Variant platform="android" task="import-library" repeat="4" mdxType="Variant" />
    <ol>
      <li parentName="ol">{`Add the following libraries in your project's `}<inlineCode parentName="li">{`build.gradle`}</inlineCode>{` file:`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`implementation 'com.adobe.marketing.mobile:core:1+'
implementation 'com.adobe.marketing.mobile:assurance:1+'
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Import the Assurance library along with the other Mobile SDK libraries:`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`import com.adobe.marketing.mobile.Assurance;
import com.adobe.marketing.mobile.MobileCore;
`}</code></pre>
    <Variant platform="ios" task="import-library" repeat="7" mdxType="Variant" />
    <p>{`Add the library to your project via your `}<a parentName="p" {...{
        "href": "https://cocoapods.org/pods/AEPAssurance"
      }}>{`Cocoapods`}</a>{` `}<inlineCode parentName="p">{`Podfile`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-pod"
      }}>{`pod 'ACPCore'
pod 'AEPAssurance','~> 1.0'
`}</code></pre>
    <p>{`Import the Assurance extension along with the other Adobe Mobile extensions:`}</p>
    <h4 {...{
      "id": "swift"
    }}>{`Swift`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`import ACPCore
import AEPAssurance
`}</code></pre>
    <h4 {...{
      "id": "objective-c"
    }}>{`Objective-C`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`#import "ACPCore.h"
#import "AEPAssurance.h"
`}</code></pre>
    <Variant platform="react-native" task="import-library" repeat="13" mdxType="Variant" />
    <ol>
      <li parentName="ol">{`Install the AEP Assurance package.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install @adobe/react-native-aepassurance@2.0.1
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Link the module.`}</li>
    </ol>
    <p><strong parentName="p">{`React Native 0.60+`}</strong></p>
    <p><a parentName="p" {...{
        "href": "https://github.com/react-native-community/cli/blob/master/docs/autolinking.md"
      }}>{`CLI autolink feature`}</a>{` links the module while building the app.`}</p>
    <p><strong parentName="p">{`React Native `}{`<`}{`= 0.59`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`react-native link @adobe/react-native-aepassurance
`}</code></pre>
    <p><strong parentName="p">{`Note`}</strong>{` For `}<inlineCode parentName="p">{`iOS`}</inlineCode>{` using `}<inlineCode parentName="p">{`cocoapods`}</inlineCode>{`, run:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`cd ios/ && pod install
`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Import the extension.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {AEPAssurance} from '@adobe/react-native-aepassurance';
`}</code></pre>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Get the extension version.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`AEPAssurance.extensionVersion().then(version => console.log("AdobeExperienceSDK: AEPAssurance version: " + version));
`}</code></pre>
    <Variant platform="flutter" task="import-library" repeat="7" mdxType="Variant" />
    <h4 {...{
      "id": "javascript"
    }}>{`JavaScript`}</h4>
    <ol>
      <li parentName="ol">{`Install the AEP Assurance package.`}</li>
    </ol>
    <p>{`Installation instructions can be found in the `}<a parentName="p" {...{
        "href": "https://pub.dev/packages/flutter_assurance/install"
      }}>{`Flutter documentation`}</a>{`.`}</p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Import the extension.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`import 'package:flutter_assurance/flutter_assurance.dart';
`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Get the extension version.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`String version = await FlutterAEPAssurance.extensionVersion;
`}</code></pre>
    <Variant platform="cordova" task="import-library" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "javascript-1"
    }}>{`JavaScript`}</h4>
    <ol>
      <li parentName="ol">{`After creating your Cordova app and adding the Android and iOS platforms, the AEPAssurance extension for Cordova can be added with this command:`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`cordova plugin add https://github.com/adobe/cordova-aepassurance.git
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Get the extension version.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`AEPAssurance.extensionVersion(function(version) {  
    console.log("AEPAssurance version: " + version);
}, function(error) {  
    console.log(error);  
});
`}</code></pre>
    <Variant platform="unity" task="import-library" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "c"
    }}>{`C#`}</h4>
    <ol>
      <li parentName="ol">{`After importing the `}<a parentName="li" {...{
          "href": "https://github.com/adobe/unity-aepassurance/tree/master/bin"
        }}>{`AEPAssurance.unitypackage`}</a>{`, the AEP Assurance extension for Unity can be added with the following code in the MainScript:`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`using com.adobe.marketing.mobile;
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Get the extension version.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`AEPAssurance.extensionVersion();
`}</code></pre>
    <Variant platform="xamarin" task="import-library" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "c-1"
    }}>{`C#`}</h4>
    <ol>
      <li parentName="ol">{`After adding the `}<a parentName="li" {...{
          "href": "https://www.nuget.org/packages/Adobe.AEPAssurance.iOS/"
        }}>{`iOS`}</a>{` or `}<a parentName="li" {...{
          "href": "https://www.nuget.org/packages/Adobe.AEPAssurance.Android/"
        }}>{`Android`}</a>{` AEP Assurance NuGet package, the Assurance extension can be added by this import statement:`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`using Com.Adobe.Marketing.Mobile;
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Get the extension version.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`AEPAssurance.ExtensionVersion();
`}</code></pre>
    <Variant platform="android" task="register-assurance" repeat="7" mdxType="Variant" />
    <p>{`To start using the extension library, you must first register the extension with the `}<a parentName="p" {...{
        "href": "../mobile-core/index.md"
      }}>{`Mobile Core`}</a>{` extension.`}</p>
    <h4 {...{
      "id": "java"
    }}>{`Java`}</h4>
    <p>{`Register the extension when you register other extensions.`}</p>
    <p>{`To find your app ID, which is mentioned below, please read the `}<a parentName="p" {...{
        "href": "../mobile-core/configuration/index.md#configure-with-app-id-per-environment"
      }}>{`Mobile Install Instructions`}</a>{`. Within the "Publishing Flow", select the small gray box next to the "Environment" dropdown.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "566px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "29.062500000000004%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/client-sdks/previous-versions/static/80db4ace0a66a85ca7634b717a6e6380/5530d/install-instructions.webp 320w", "/client-sdks/previous-versions/static/80db4ace0a66a85ca7634b717a6e6380/2ba41/install-instructions.webp 566w"],
            "sizes": "(max-width: 566px) 100vw, 566px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/client-sdks/previous-versions/static/80db4ace0a66a85ca7634b717a6e6380/dd4a7/install-instructions.png 320w", "/client-sdks/previous-versions/static/80db4ace0a66a85ca7634b717a6e6380/7ef45/install-instructions.png 566w"],
            "sizes": "(max-width: 566px) 100vw, 566px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/client-sdks/previous-versions/static/80db4ace0a66a85ca7634b717a6e6380/7ef45/install-instructions.png",
            "alt": "install instructions",
            "title": "install instructions",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{` public class MobileApp extends Application {
    @Override
    public void onCreate() {
        super.onCreate();
        MobileCore.setApplication(this);

        try {
        // register other necessary extensions
        Assurance.registerExtension();            
        MobileCore.start(new AdobeCallback() {
            @Override
            public void call(final Object o) {
                MobileCore.configureWithAppID("yourAppId");
            }});
        } catch (Exception e) {
        // Log the exception
        }
    }
}
`}</code></pre>
    <Variant platform="ios" task="register-assurance" repeat="5" mdxType="Variant" />
    <p>{`To start using the extension library, you must first register the extension with the `}<a parentName="p" {...{
        "href": "../mobile-core/index.md"
      }}>{`Mobile Core`}</a>{` extension.`}</p>
    <h4 {...{
      "id": "swift-1"
    }}>{`Swift`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`func application(_ application: UIApplication, didFinishLaunchingWithOptions launchOptions: [UIApplication.LaunchOptionsKey: Any]?) -> Bool {
       // set app id from the Data Collection UI
     ACPCore.configure(withAppId: "yourAppId")
     AEPAssurance.registerExtension()
     ACPCore.start(nil)
     return true;
}
`}</code></pre>
    <h4 {...{
      "id": "objective-c-1"
    }}>{`Objective-C`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`- (BOOL)application:(UIApplication *)application didFinishLaunchingWithOptions:(NSDictionary *)launchOptions {
    [ACPCore configureWithAppId:@"yourAppId"]; // set app id from the Data Collection UI
    [AEPAssurance registerExtension];
    [ACPCore start:nil];
    return YES;
 }
`}</code></pre>
    <Variant platform="react-native" task="register-assurance" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "javascript-2"
    }}>{`JavaScript`}</h4>
    <p>{`When using React Native, register AEP Assurance with Mobile Core in native code as shown on the Android and iOS tabs.`}</p>
    <Variant platform="flutter" task="register-assurance" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "dart"
    }}>{`Dart`}</h4>
    <p>{`When using Flutter, register AEP Assurance with Mobile Core in native code as shown on the Android and iOS tabs.`}</p>
    <Variant platform="cordova" task="register-assurance" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "javascript-3"
    }}>{`JavaScript`}</h4>
    <p>{`When using Cordova, register AEP Assurance with Mobile Core in native code as shown on the Android and iOS tabs.`}</p>
    <Variant platform="unity" task="register-assurance" repeat="3" mdxType="Variant" />
    <h4 {...{
      "id": "c-2"
    }}>{`C#`}</h4>
    <p>{`Register the extension in the `}<inlineCode parentName="p">{`start()`}</inlineCode>{` function:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`using com.adobe.marketing.mobile;
using using AOT;

public class MainScript : MonoBehaviour
{
    [MonoPInvokeCallback(typeof(AdobeStartCallback))]
    public static void HandleStartAdobeCallback()
    {   
        // set app id from the Data Collection UI
        ACPCore.ConfigureWithAppID("yourAppId");
    }

    // Start is called before the first frame update
    void Start()
    {   
        AEPAssurance.registerExtension();
        ACPCore.Start(HandleStartAdobeCallback);
    }
}
`}</code></pre>
    <Variant platform="xamarin" task="register-assurance" repeat="6" mdxType="Variant" />
    <p><strong parentName="p">{`iOS`}</strong></p>
    <p>{`Register the AEPAssurance extension in your app's `}<inlineCode parentName="p">{`FinishedLaunching()`}</inlineCode>{` function:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public override bool FinishedLaunching(UIApplication app, NSDictionary options)
{
  global::Xamarin.Forms.Forms.Init();
  LoadApplication(new App());
  AEPAssurance.RegisterExtension();
  // start Mobile Core
  ACPCore.Start(startCallback);
  return base.FinishedLaunching(app, options);
}

private void startCallback()
{
  // set app id from the Data Collection UI
  ACPCore.ConfigureWithAppID("yourAppId");
}
`}</code></pre>
    <p><strong parentName="p">{`Android`}</strong></p>
    <p>{`Register the AEPAssurance extension in your app's `}<inlineCode parentName="p">{`OnCreate()`}</inlineCode>{` function:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`protected override void OnCreate(Bundle savedInstanceState)
{
  base.OnCreate(savedInstanceState);
  global::Xamarin.Forms.Forms.Init(this, savedInstanceState);
  LoadApplication(new App());
  AEPAssurance.RegisterExtension();

  // start Mobile Core
  ACPCore.Start(new CoreStartCompletionCallback());
}

class CoreStartCompletionCallback : Java.Lang.Object, IAdobeCallback
{
  public void Call(Java.Lang.Object callback)
  {
    // set app id from the Data Collection UI
    ACPCore.ConfigureWithAppID("yourAppId");
  }
}
`}</code></pre>
    <Variant platform="ios" task="implement-assurance" repeat="12" mdxType="Variant" />
    <h4 {...{
      "id": "swift-2"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`func application(_ app: UIApplication, open url: URL, options: [UIApplication.OpenURLOptionsKey : Any] = [:]) -> Bool {
    AEPAssurance.startSession(url)
    return true
}
`}</code></pre>
    <p>{`In iOS 13 and later, for a scene-based application, use the `}<inlineCode parentName="p">{`UISceneDelegate`}</inlineCode>{`'s `}<inlineCode parentName="p">{`scene(_:openURLContexts:)`}</inlineCode>{` method as follows:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`func scene(_ scene: UIScene, openURLContexts URLContexts: Set<UIOpenURLContext>) {
    AEPAssurance.startSession((URLContexts.first!).url)
}
`}</code></pre>
    <h4 {...{
      "id": "objective-c-2"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`+ (void) startSession: (NSURL* _Nonnull) url;
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`- (BOOL)application:(UIApplication *)app openURL:(nonnull NSURL *)url options:(nonnull NSDictionary<UIApplicationOpenURLOptionsKey,id> *)options {
    [AEPAssurance startSession:url];
    return true;
}
`}</code></pre>
    <p>{`In iOS 13 and later, for a scene-based application, use the `}<inlineCode parentName="p">{`UISceneDelegate`}</inlineCode>{`'s `}<inlineCode parentName="p">{`scene(_:openURLContexts:)`}</inlineCode>{` method as follows:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`- (void) scene:(UIScene *)scene openURLContexts:(NSSet<UIOpenURLContext *> *)URLContexts {
    UIOpenURLContext * urlContext = URLContexts.anyObject;
    if (urlContext != nil) {
        [AEPAssurance startSession:urlContext.URL];
    }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      